interface AccentButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}

export const AccentButton: React.FC<AccentButtonProps> = ({ 
  children, 
  onClick, 
  disabled = false,
  className = '',
  'aria-label': ariaLabel,
  ...props
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      role="button"
      style={{ outline: 'none' }}
      {...props}
      className={`group bg-gradient-to-r from-orange-500 to-pink-500 px-6 py-3 rounded-xl 
        text-white hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl 
        relative overflow-hidden disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center gap-2 ${className}`}
    >
      <span className="relative z-10 inline-flex items-center gap-2">{children}</span>
      <div className="absolute inset-0 bg-gradient-to-r from-pink-500 to-orange-500 
        opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
    </button>
  );
}; 